// @flow
import React from 'react';
import _ from 'lodash';
import * as RenterApp from 'styles/Home/StyledRenterApplication';
import styled from 'styled-components';
import BillDataForm from 'components/shared/BillDataFormComponent';
import UserActions from 'actions/CurrentUserActions';
import AppStore from 'stores/AppStore';
import HomieContext from 'HomieContext';
import LegalEntity from 'models/LegalEntity';
import swal from '@sweetalert/with-react';

const Content = styled.div`
  display: block;
`;

const BoxContentInfo = styled.div`
  min-height: 60px;
  width: 100%;
  margin-bottom: 2px;
  padding: 10px 15px;
  background-color: #f9f9f9;
`;

const BoxContentInfoEdit = styled(BoxContentInfo)`
  display: block;
  background: #fff;
`;

const Title = styled.div`
  height: 17px;
  color: #9b9b9b;
  font-size: 14px;
  line-height: 17px;
  text-align: left;
  margin-bottom: 5px;
`;

const InfoText = styled.div`
  height: 19px;
  color: #4a4a4a;
  font-size: 16px;
  line-height: 20px;
  text-align: left;
`;

const InfoTextEdit = styled.div`
  height: 40px;
  color: #278c7e;
  font-size: 14px;
  line-height: 40px;
  cursor: pointer;
  text-align: left;
`;

const SendText = styled.div`
  display: block;
  height: 19px;
  color: #4a4a4a;
  font-size: 16px;
  line-height: 19px;
  text-align: center;
  margin-bottom: 10px;
`;

const InputBlocked = styled.div`
  display: block;
  height: 35px;
  width: calc(100% - 16px);
  border: 1px solid #ececec;
  border-radius: 2px;
  background-color: #ececec;
  padding: 8px;
  margin-bottom: 10px;
  margin-left: 8px;
  color: #9b9b9b;
`;

const DataConfirmText = styled.div`
  display: block;
  height: 22px;
  color: #4a4a4a;
  font-size: 18px;
  font-weight: bold;
  line-height: 22px;
  text-align: center;
  margin-top: 20px;
  margin-bottom: 20px;
`;

const BillContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  position: relative;
  max-height: ${props => (props.isVisible ? 'auto' : '0')};
  overflow: hidden;
`;

type State = {
  legalEntity: LegalEntity,
  showForm: boolean,
  spinnerVisible: boolean
};

type PropsType = {
  visible: boolean,
  handleClickNotBillAction: () => void,
  onBillRequestSuccess: (response: any) => void,
  concept: string,
  recordId: string,
  allowBilling?: boolean,
  enableForm?: boolean,
  updateLegalEntityStatus?: () => void,
  updateTenantRequireInvoiceStatus?: () => void,
  showNotBilling: boolean,
  operationFrom?: any,
  isForAdvisor?: boolean,
  color?: string
};

class BillPayment extends React.Component<PropsType, State> {
  static defaultProps = {
    color: '#278C7E'
  };

  constructor(props: PropsType) {
    super(props);
    this.state = {
      showForm: true,
      legalEntity: new LegalEntity({}),
      spinnerVisible: false
    };
  }

  componentWillMount() {
    AppStore.addChangeListener(this.onChange);
  }

  componentWillUnmount() {
    AppStore.removeChangeListener(this.onChange);
  }

  componentDidMount() {
    const legalEntity = this.getLegalEntity();
    if (legalEntity.email === '') {
      legalEntity.email = this.context.currentUser.email;
    }
    this.setState({ legalEntity, showForm: legalEntity.id ? false : true });
  }

  onChange = (): void => {
    const legalEntity = this.getLegalEntity();
    this.setState({ legalEntity, showForm: false });
    if (!this.props.isForAdvisor) this.context.hideLoadingProcessView();
    else this.setState({ spinnerVisible: false });
  };

  getLegalEntity = (): LegalEntity => {
    const legalEntity = AppStore.getLegalEntity();
    if (_.isUndefined(legalEntity)) {
      return new LegalEntity({ email: this.context.currentUser.email });
    }
    return new LegalEntity(legalEntity);
  };

  handleBillRequest = (value: boolean): void => {
    if (this.props.operationFrom === 'firstPayment') {
      this.props.updateTenantRequireInvoiceStatus(value);
    }
  };

  successResponse = (response: any) => {
    if (!this.props.isForAdvisor) this.context.hideLoadingProcessView();
    else this.setState({ spinnerVisible: false });
    this.props.onBillRequestSuccess(response);
  };

  errorResponse = (response: any) => {
    swal(
      '¡Ha ocurrido un error!',
      response.responseJSON
        ? response.responseJSON.message
        : 'Error. Inténtelo más tarde.',
      'error',
      {
        timer: 5000
      }
    );
    if (!this.props.isForAdvisor) this.context.hideLoadingProcessView();
    else this.setState({ spinnerVisible: false });
  };

  showForm = (): void => {
    this.setState({
      showForm: true
    });
  };

  _handleContinueAction = (legalEntity: LegalEntity) => {
    if (!this.props.isForAdvisor)
      this.context.showLoadingProcessView('Guardando datos');
    else this.setState({ spinnerVisible: true });
    if (legalEntity.id) {
      UserActions.updateBillData(
        { legal_entity: legalEntity },
        this.context.currentUser.id,
        legalEntity.id,
        () => {
          if (!this.props.isForAdvisor) this.context.hideLoadingProcessView();
          else this.setState({ spinnerVisible: false });
        }
      );
    } else {
      UserActions.createBillData(
        { legal_entity: legalEntity },
        this.context.currentUser.id,
        () => {
          if (!this.props.isForAdvisor) this.context.hideLoadingProcessView();
          else this.setState({ spinnerVisible: false });
        }
      );
    }
    if (
      this.props.operationFrom === 'homeApplicationPayment' ||
      this.props.operationFrom === 'meeroPhotoshootingPayment'
    ) {
      this.props.updateLegalEntityStatus();
    }
  };

  _handleClickNoBill = () => {
    this.setState(
      {
        showForm: false
      },
      this.props.handleClickNotBillAction
    );
  };

  renderButtonAllowBilling = () => {
    const { allowBilling = true } = this.props;
    if (allowBilling)
      return (
        <div>
          <BoxContentInfoEdit>
            <RenterApp.SubmitButton
              disabled={!allowBilling}
              onClick={() => {
                this.handleBillRequest(true);
              }}
            >
              Solicitar factura
            </RenterApp.SubmitButton>
          </BoxContentInfoEdit>
          <BoxContentInfoEdit>
            <RenterApp.SubmitButton
              style={{ background: '#ffffff', color: '#4a4a4a' }}
              disabled={!allowBilling}
              onClick={() => {
                this.handleBillRequest(false);
              }}
            >
              No requiero factura
            </RenterApp.SubmitButton>
          </BoxContentInfoEdit>
        </div>
      );
    else return null;
  };

  render() {
    const { visible, enableForm = true, color } = this.props;
    const { legalEntity, showForm, spinnerVisible } = this.state;
    if (_.isUndefined(legalEntity)) {
      return null;
    }
    const address = legalEntity.address;
    return (
      <BillContainer isVisible={visible}>
        {!showForm && (
          <Content>
            {enableForm && (
              <div>
                <DataConfirmText>Confirmación de datos</DataConfirmText>
                <SendText>Enviaremos las facturas a</SendText>
                <InputBlocked>{legalEntity.email}</InputBlocked>
                <BoxContentInfo>
                  <Title>Razón social</Title>
                  <InfoText>{legalEntity.business_name}</InfoText>
                </BoxContentInfo>
                <BoxContentInfo>
                  <Title>RFC</Title>
                  <InfoText>{legalEntity.rfc}</InfoText>
                </BoxContentInfo>
                <BoxContentInfo>
                  <Title>Dirección</Title>
                  <InfoText>Calle: {address.street}</InfoText>
                  <InfoText>Colonia: {address.neighborhood}</InfoText>
                  <InfoText>Número {address.ext_number}</InfoText>
                  <InfoText>Número int: {address.int_number}</InfoText>
                  <InfoText>Distrito: {address.district}</InfoText>
                  <InfoText>Delegación: {address.town}</InfoText>
                  <InfoText>Estado: {address.state}</InfoText>
                  <InfoText>País: {address.country}</InfoText>
                  <InfoText>Código postal: {address.zip}</InfoText>
                </BoxContentInfo>
                <BoxContentInfo>
                  <InfoTextEdit centered onClick={this.showForm}>
                    Editar Datos
                  </InfoTextEdit>
                </BoxContentInfo>
              </div>
            )}
            {this.renderButtonAllowBilling()}
          </Content>
        )}
        {showForm && enableForm && (
          <Content>
            <BillDataForm
              handleClickBillAction={this._handleContinueAction}
              lineVisible={false}
              visible={true}
              legalEntity={legalEntity}
              handleClickNotBillAction={this._handleClickNoBill}
              showNotBilling={this.props.showNotBilling}
              updateTenantRequireInvoiceStatus
              spinnerVisible={spinnerVisible}
              color={color}
            />
          </Content>
        )}
      </BillContainer>
    );
  }
}

BillPayment.contextType = HomieContext;
export default BillPayment;
